/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Tier_Lists_DescriptionInputs */



/**
* | output |
* | --- |
* | "Rank a set on a board and share it" |
*
* @param {Nav_Tier_Lists_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const nav_tier_lists_description = /** @type {((inputs?: Nav_Tier_Lists_DescriptionInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Tier_Lists_DescriptionInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Ein Set auf einem Board einsortieren und teilen")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Classez un set sur un tableau et partagez-le")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("在面板上给一个系列排名并分享")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("在版面上為一個套組排名並分享出去")
	if (locale === "ko") return /** @type {LocalizedString} */ ("세트를 보드에서 순위 매기고 공유")
	return /** @type {LocalizedString} */ ("Rank a set on a board and share it")
});